module.exports = __webpack_public_path__ + "static/media/loyalty-icon-web.04d47a63.png";